var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightBottomBall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 202,
    viewBox: "0 0 201 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4309 166.633C2.29443 132.228 0.790347 74.9359 35.0714 38.6683C69.3525 2.40069 126.437 0.891148 162.574 35.2966C198.71 69.7021 200.214 126.994 165.933 163.262C131.652 199.529 74.5673 201.039 38.4309 166.633Z",
    fill: "url(#paint0_radial_1_61)",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_61",
    x: 0.31311,
    y: 0.448486,
    width: 200.378,
    height: 201.033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_1_61"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_61",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.654 113.831) rotate(143.829) scale(89.4676 89.5665)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFABDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66FC0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBottomBall);
export default __webpack_public_path__ + "static/media/right-bottom-ball.9d535e66830cdc0e872a10bd06da11c7.svg";
export { ForwardRef as ReactComponent };